import { Skeleton } from 'features/fast-order/FastOrderSkeleton/styled';
import { Flex } from 'features/fast-order/Flex';
import { RangeSkeleton } from './styled';

const TradingFormSkeleton = () => (
  <Flex direction="column" justify="space-between" style={{ height: '100%' }}>
    <Flex direction="column" p={16}>
      <Flex direction="column" gap="16px">
        <Skeleton width={180} height={12} />
        <RangeSkeleton />
        <Flex gap={16} align="center" justify="space-between">
          <Skeleton width={80} height={12} />
          <Skeleton width={140} height={12} />
        </Flex>
        <Flex gap={16} align="center" justify="space-between">
          <Skeleton width={80} height={12} />

          <Skeleton width={80} height={12} />
        </Flex>
        <Flex gap={16} align="center" justify="space-between">
          <Skeleton width={80} height={12} />

          <Skeleton width={80} height={12} />
        </Flex>
        <Flex gap={16} align="center" justify="space-between">
          <Skeleton width={80} height={12} />
          <Skeleton width={140} height={12} />
        </Flex>
        <Flex gap={16} align="center" justify="space-between">
          <Skeleton width={80} height={12} />
          <Skeleton width={140} height={12} />
        </Flex>
        <Flex gap={16} align="center" justify="space-between">
          <Skeleton width={80} height={12} />
          <Skeleton width={80} height={12} />
        </Flex>
      </Flex>
    </Flex>
  </Flex>
);

export default TradingFormSkeleton;
